import { createSchemaValidator } from 'src/utils/createSchemaValidator';
import { SETTINGS_FORM_SCHEMA } from 'src/react/settings/constants/SettingsFormSchema';

export const settingsFormValidator = createSchemaValidator(SETTINGS_FORM_SCHEMA);
